import React from 'react';

const EnabledColumn = (rowData) =>
  rowData?.json?.status || rowData?.status === '1' ? <span>Active</span> : <span>Inactive</span>;

export default EnabledColumn;
